import {
  Icon,
  InlineChildren,
  Spacing,
  StackChildren,
  Text,
} from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { AbnImage } from './abn-how-to/AbnImage'

const StyledUl = styled.ul`
  padding-left: ${Spacing.Small}px;
`

interface IBulletWithIcon {
  text: i18nKeys
  icon: string
}
export interface IStep {
  title?: i18nKeys
  image?: string
  instructions?: i18nKeys[]
  bullets?: i18nKeys[]
  bulletsWithIcon?: IBulletWithIcon[]
  isSection?: boolean
}

const Header = ({ styles, children }) => (
  <Text tag="h1" styles={styles}>
    {children}
  </Text>
)

const BodyText = ({ children }) => (
  <Text tag="p" styles={Text.Styles.Body1} color={Text.Colors.TextSecondary}>
    {children}
  </Text>
)

export function Step({
  title,
  image,
  instructions,
  bullets,
  bulletsWithIcon,
  isSection,
}: IStep) {
  const headerStyle = isSection
    ? Text.Styles.Label1Emphasis
    : Text.Styles.Title1

  return (
    <StackChildren>
      {title && <Header styles={headerStyle}>{i18n.t(title)}</Header>}
      {image && <AbnImage url={image} title={i18n.t(title)} />}
      {instructions &&
        instructions.map(instruction => (
          <BodyText key={instruction}> {i18n.t(instruction)}</BodyText>
        ))}
      {bullets && (
        <StyledUl>
          <StackChildren>
            {bullets.map(bullet => (
              <BodyText>
                <li key={bullet}>{i18n.t(bullet)}</li>
              </BodyText>
            ))}
          </StackChildren>
        </StyledUl>
      )}
      {bulletsWithIcon && (
        <StackChildren size={StackChildren.Sizes.XxSmall}>
          {bulletsWithIcon.map(item => (
            <BodyText>
              <InlineChildren
                key={item.text}
                size={InlineChildren.Sizes.Medium}
              >
                <Icon type={item.icon} size={Icon.Sizes.Medium} />
                <span>{i18n.t(item.text)}</span>
              </InlineChildren>
            </BodyText>
          ))}
        </StackChildren>
      )}
    </StackChildren>
  )
}
